<template>
  <div
    :class="[
      { 'scss-click-effect': clickable },
      'd-flex flex-row flex-fill scss-medium-font style-container',
    ]"
  >
    <!-- Product Image -->
    <div class="me-2">
      <smart-image
        class="style-img"
        :imageURL="imgUrl" />
    </div>
    <div class="d-flex flex-column text-start my-auto flex-fill py-2 px-1 min-w-0">
      <!-- Name -->
      <div class="scss-bold style-name">
        {{ name }}
      </div>

      <!-- Duration/Processing time -->
      <div v-if="processingTime">
        <div>
          <span>
            {{ processingTime }}
          </span>
        </div>
      </div>

      <!-- Description -->
      <div class="scss-overflow-text-style" v-if="description">
        {{ description }}
      </div>

      <!-- Price & Details -->
      <div class="d-flex flex-row flex-wrap" v-if="!hidePrice">
        <div class="scss-text-blue style-content-padding fw-bold">
          <i class="bi bi-tag"></i>
          <span class="scss-dollar-sign-style">
            {{ branchCurrencySymbol }}
          </span>
          <span>
            {{ formatPrice(salePrice) }}
          </span>
        </div>
        <div class="scss-text-line-through" v-if="originalPrice">
          <span class="scss-dollar-sign-style">
            {{ branchCurrencySymbol }}
          </span>
          <span>
            {{ formatPrice(originalPrice) }}
          </span>
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatPrice } from "@/common/helpers/PriceHelper.js";
import SmartImage from "@/components/SmartImage.vue";

export default {
  name: "ExpandableListItem",
  components: {
    SmartImage,
  },
  computed: {
    ...mapGetters(["branchCurrencySymbol"]),
  },
  props: {
    clickable: {
      type: Boolean,
      default: true,
    },
    processingTime: String,
    description: String,
    hidePrice: { // hide originalPrice and salePrice
      type: [Boolean, Number],
      default: false,
    },
    imgUrl: String,
    name: String,
    originalPrice: String,
    salePrice: String,
  },
  methods: {
    formatPrice,
  },
};
</script>

<style lang="scss" scoped>
.style-img {
  max-width: 120px;
  min-width: 120px;
  max-height: 100%;
  min-height: 110px;
  object-fit: cover;
}

.style-name {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.style-content-padding {
  padding-right: 5%;
}

.style-container {
  height: 110px;
}

.style-price-details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
</style>
